import React from 'react';
import { useTranslationForType } from '../../../payment/ui/credit-card/hooks/useTranslationForType';
import { trimMaskedCardNumber } from './helpers/trimMaskedCardNumber';
import { IPaymentDetails } from '../../domain/booking/models/IPaymentDetails';
import { IBookingPaymentDetails } from '../../domain/booking/models/IBooking';
import { CreditCardType } from '../../../payment/domain/models';

interface IBookingPaymentMethodProps {
	paymentDetails: IPaymentDetails | IBookingPaymentDetails;
}

export const BookingPaymentMethod = ({
	paymentDetails,
}: IBookingPaymentMethodProps) => {
	const { creditCardType, maskedCreditCardNumber } = paymentDetails;

	const formattedNumber = maskedCreditCardNumber
		? trimMaskedCardNumber(maskedCreditCardNumber)
		: '';

	if (!creditCardType) {
		return <>{formattedNumber}</>;
	}

	if (!maskedCreditCardNumber) {
		return null;
	}

	return (
		<BookingPaymentMethodWithCreditCard
			creditCardType={creditCardType}
			formattedCreditCardNumber={formattedNumber}
		/>
	);
};

const BookingPaymentMethodWithCreditCard = ({
	creditCardType,
	formattedCreditCardNumber,
}: {
	creditCardType: CreditCardType;
	formattedCreditCardNumber: string;
}) => {
	const cardName = useTranslationForType(creditCardType);

	return <>{`${cardName} ${formattedCreditCardNumber}`}</>;
};
